import { NO_TRANSLATE_CLASS } from "@flat-ui";
import { DevFeaturesTable } from "@components/dev-features-dialog/dev-features-table";
import { renderPageAction } from "@components/dev-features-dialog/dev-features-table-actions";
import {
  DEV_PAGES,
  DevPageItem,
  DevPageNavigationKey,
} from "@components/dev-features-dialog/dev-pages";
import { ButtonsCallback } from "@components/dev-features-dialog/features";
import { useAppNavigation } from "@router/use-app-navigation";
import { isProductionEnvironment } from "@utils/env-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { ExperimentalFeatureEvents } from "@utils/track-event/track-event-list";

interface DevPagesPanelProps {
  /** Callback invoked after navigating, used to close the dialog */
  onNavigate: () => void;
}

/**
 * Panel with a table listing pages the user can navigate to from the dev dialog.
 */
export function DevPagesPanel({
  onNavigate,
}: DevPagesPanelProps): React.JSX.Element {
  const { trackEvent } = useTrackEvent();
  const { navigateToAboutProductsPage, navigateToTestingImpersonationPage } =
    useAppNavigation();

  const navigationHandlers: Record<DevPageNavigationKey, ButtonsCallback> = {
    aboutProducts: navigateToAboutProductsPage,
    testingImpersonation: navigateToTestingImpersonationPage,
  };

  const pages: DevPageItem[] = DEV_PAGES.filter(
    (page) => !(page.isHiddenInProduction && isProductionEnvironment)
  ).map((page) => ({
    label: page.label,
    description: page.description,
    onOpen: () => {
      trackEvent({
        name: ExperimentalFeatureEvents.openDevPage,
        props: { page: page.label },
      });
      navigationHandlers[page.navigationKey]();
      onNavigate();
    },
  }));

  return (
    <div className={NO_TRANSLATE_CLASS}>
      <DevFeaturesTable
        title="Pages"
        items={pages}
        renderAction={renderPageAction}
      />
    </div>
  );
}
